"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const KeyboardArrowDown_1 = __importDefault(require("@material-ui/icons/KeyboardArrowDown"));
const KeyboardArrowRight_1 = __importDefault(require("@material-ui/icons/KeyboardArrowRight"));
function TableBody(_a) {
    var { page, prepareRow, wrapText = true, reactTableBodyProps, styles } = _a, props = __rest(_a, ["page", "prepareRow", "wrapText", "reactTableBodyProps", "styles"]);
    return (react_1.default.createElement(TableBody_1.default, Object.assign({}, reactTableBodyProps, { "data-testid": props['data-testid'] }), page
        .map((row) => {
        prepareRow(row);
        return row;
    })
        .map((row) => (react_1.default.createElement(TableRow_1.default, Object.assign({ selected: row.isSelected }, row.getRowProps(), { className: clsx_1.default({ [styles.aggregated]: row.isGrouped }) }), row.cells.map((cell) => {
        return (react_1.default.createElement(TableCell_1.default, Object.assign({}, cell.getCellProps()), cell.isGrouped ? (react_1.default.createElement("div", { className: styles.cellAlign },
            react_1.default.createElement("span", { className: clsx_1.default({ [styles.ellipsizeText]: !wrapText }) },
                react_1.default.createElement("b", null,
                    cell.render('Cell'),
                    " (",
                    row.subRows.length,
                    ")")),
            row.isExpanded ? (react_1.default.createElement(KeyboardArrowDown_1.default, Object.assign({}, row.getToggleRowExpandedProps()))) : (react_1.default.createElement(KeyboardArrowRight_1.default, Object.assign({}, row.getToggleRowExpandedProps()))))) : (
        // If the cell is aggregated, use the Aggregated
        // renderer for cell, otherwise, just render the regular cell
        react_1.default.createElement("div", { className: clsx_1.default({ [styles.ellipsizeText]: !wrapText }) }, cell.render(cell.isAggregated ? 'Aggregated' : 'Cell')))));
    }))))));
}
exports.default = TableBody;
//# sourceMappingURL=index.js.map